import React from 'react';

import OutputText from '@ey/canvascoreservices/OutputText';

const CustomColumn = ({item, c}) => {
	const text = item.customColumns?.find((x) => x.id === c.id)?.options[0]?.option || '';

	return (
		<OutputText body2 light ellipsis title={text}>
			{text}
		</OutputText>
	);
};

export const config = (c) => ({
	id: c.id,
	label: c.label,
	propName: 'custom',
	width: 'var(--px-200)',
	customCell: (item) => {
		const props = {item, c};
		return <CustomColumn {...props} />;
	}
});
